import fetchAPI from '../../../../lib/utils/fetch-api'
import {
  NotificationItem,
  NotificationSetting,
  NotificationSettingsResponse,
  NotificationSoundKey,
  NotificationStatus,
} from './types'

interface NotificationsResponse {
  items: NotificationItem[]
  unread_count: number
  has_more: boolean
}

export const fetchNotifications = async (
  status: NotificationStatus,
  page = 1,
  pageSize = 20,
): Promise<NotificationsResponse> => {
  return (await fetchAPI(
    `/api/notifications?status=${status}&page=${page}&pageSize=${pageSize}`,
  )) as unknown as NotificationsResponse
}

export const readNotification = async (id: number): Promise<{ item: NotificationItem }> => {
  return (await fetchAPI(`/api/notifications/${id}/read`, {
    method: 'POST',
  })) as unknown as { item: NotificationItem }
}

export const readAllNotifications = async (): Promise<void> => {
  await fetchAPI('/api/notifications/read-all', {
    method: 'POST',
  })
}

export const fetchNotificationSettings = async (): Promise<NotificationSettingsResponse> =>
  (await fetchAPI('/api/notifications/settings')) as unknown as NotificationSettingsResponse

export const saveNotificationSettings = async (
  settings: NotificationSetting[],
): Promise<NotificationSettingsResponse> =>
  (await fetchAPI('/api/notifications/settings', {
    method: 'POST',
    body: JSON.stringify({ settings }),
  })) as unknown as NotificationSettingsResponse

export const saveNotificationSound = async (
  soundKey: NotificationSoundKey,
): Promise<NotificationSettingsResponse> =>
  (await fetchAPI('/api/notifications/settings', {
    method: 'POST',
    body: JSON.stringify({ sound_key: soundKey }),
  })) as unknown as NotificationSettingsResponse
